<template>
  <div class="d-flex flex-column justify-content-center position-relative w-100 h-100">
    <div class="disabled-overlay"></div>
    <!-- bloc pour l'image de background -->
    <MediaImageFocalPoint
      :content="{
        formatRatio: ratioImage,
        image: content.image,
        altImage: content.altImage,
        isBackground: true,
        lien: { field: 'lienInterne' },
        preload: preloadForAnimation,
      }"
      :show="show"
      :style="{ 'background-color': content.couleur }"
      class="image-fond h-100"
      @lazyImgLoaded.once="onLazyImgLoaded"
    >
    </MediaImageFocalPoint>
    <div
      ref="imgsupp"
      :class="{ 'ready-for-animation': imgLoaded }"
      class="images-supplementaires position-absolute"
    >
      <div class="degrade"></div>
      <!-- bloc pour l'image de personnage -->
      <MediaImageFocalPoint
        v-if="content.image3 !== undefined && content.image.metadata && content.image3.metadata"
        class="position-absolute additionnelle"
        :class="content.positionnementImage3"
        :content="{
          formatRatio: '4x3',
          image: content.image3,
          lien: { field: 'lienInterne' },
          preload: preloadForAnimation,
        }"
        :show="show"
        @lazyImgLoaded.once="onLazyImgLoaded"
      >
      </MediaImageFocalPoint>
      <!-- bloc pour le logo -->
      <MediaImageFocalPoint
        v-if="content.image2 !== undefined && content.image.metadata && content.image2.metadata"
        class="position-absolute centre h-100 w-100 justify-content-center logo"
        :content="{
          formatRatio: '16x9',
          image: content.image2,
          lien: { field: 'lienInterne' },
          isLogo: true,
          preload: preloadForAnimation,
        }"
        :show="show"
        @lazyImgLoaded.once="onLazyImgLoaded"
      >
      </MediaImageFocalPoint>
    </div>
  </div>
</template>

<script>
import MediaImageFocalPoint from '@/components/media/image/MediaImageFocalPoint';

export default {
  name: 'MediaImageX3',
  components: { MediaImageFocalPoint },
  props: {
    content: { type: Object, required: true },
    show: { type: Boolean, default: false },
    preloadForAnimation: { type: Boolean, default: false },
  },
  data() {
    return {
      largeurEcran: window.innerWidth,
      imgLoaded: false,
      nbImagesTotal: 0,
      nbImagesLoaded: 0,
    };
  },
  computed: {
    ratioImage() {
      const formatRatio = this.content.formatRatio ? this.content.formatRatio : 'auto';
      if (formatRatio == '4x3' && this.largeurEcran <= 230) {
        return '1x1';
      }
      // (3x4 non-supporté)
      // if (formatRatio == '1x1' && this.largeurEcran <= 230) {
      //   return '3x4';
      // }
      return formatRatio;
    },
  },
  created() {
    if (this.content.image || this.content.image2 || this.content.image3) {
      this.nbImagesTotal++;
    }
  },
  mounted() {
    if (this.preloadForAnimation) {
      this.$refs.imgsupp.style.opacity = '0';
    }
  },
  methods: {
    onLazyImgLoaded() {
      if (this.preloadForAnimation) {
        if (this.nbImagesTotal > 0) {
          if (this.$refs.imgsupp.clientHeight > 0) {
            this.nbImagesLoaded++;
            this.imgLoaded = true;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  .image-fond::v-deep img {
    object-fit: cover;
  }
  .images-supplementaires,
  .additionnelle {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
}

.produitDesactive .disabled-overlay {
  position: absolute;
  width: 100%;
  top: 0;
  background: #ffffff;
  opacity: 0.8;
  height: 100%;
  z-index: 1;
}

.ready-for-animation {
  -webkit-animation-name: fade-in;
  -webkit-animation-duration: 0.5s;
  animation-name: fade-in;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
